import {ButtonProps, Icon} from "@chakra-ui/react";
import {ArrowRightIcon} from "@heroicons/react/20/solid";
import Button from "./Button";

const CTAButton = ({href, ...props}: {href: string} & ButtonProps) => (
  <Button
    size="lg"
    href={href}
    rounded="full"
    colorPalette="green"
    border="3px solid {colors.colorPalette.300}"
    {...props}
  >
    {props.children ?? "Contact us"}
    <Icon size="md">
      <ArrowRightIcon />
    </Icon>
  </Button>
);

export default CTAButton;
